import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DateUtils from '../../../utils/DateUtils';
import config from '../../../config';
import moment from 'moment';
import NumberUtils from '../../../utils/NumberUtils';
import StringConstant from '../../../constants/StringConstants';

function ActiveDirectDebitFields({ activeData }) {
  const endDate = moment(
    DateUtils.getMomentFromDateString(activeData.when)
  ).format(config.dateFormatTimeline);

  return (
    <dl className="c-definitions">
      <dt className="c-definitions__key">From</dt>
      <dd className="c-definitions__value">{`${activeData.fromAccountName}-${activeData.fromAccountNumber}`}</dd>
      <dt className="c-definitions__key">To</dt>
      <dd className="c-definitions__value">{activeData.toAccountName}</dd>
      <dt className="c-definitions__key">Last amount</dt>
      <dd className="c-definitions__value">
        {_.isNumber(activeData.amount) ? (
          <strong>
            {NumberUtils.decimalFormat(activeData.amount, 3, true)}
          </strong>
        ) : (
          StringConstant.unAvailable
        )}
      </dd>
      <dt className="c-definitions__key">Last paid</dt>
      <dd className="c-definitions__value">
        {endDate === StringConstant.INVALID_DATE
          ? StringConstant.unAvailable
          : endDate}
      </dd>
      <dt className="c-definitions__key">Last payment reference</dt>
      <dd className="c-definitions__value">{activeData.reference}</dd>
    </dl>
  );
}

ActiveDirectDebitFields.propTypes = {
  activeData: PropTypes.object,
};

export default ActiveDirectDebitFields;
